import { html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseLitElement } from '../base-lit-element';
import styles from './modal-buttons-style.scss';

// keep in synk global.d.ts
@customElement('md-modal-buttons')
export class ModalButtons extends BaseLitElement {

  public static styles = styles;

  @property({ type: String, attribute: true, reflect: true }) slot = 'modalButtons';

  render(): TemplateResult {
    return html`
      <slot></slot>
          `;
  }
}
